import React, { forwardRef } from "react";
import "./bottomDialog.scss";
import {
  Slide,
  Dialog,
  IconButton,
  DialogContent,
  useMediaQuery,
} from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const BottomDialog = ({
  open,
  onClose,
  children,
  dialogAction,
  isDialogAction,
  disabled,
}) => {
  const isMobile = useMediaQuery("(max-width: 600px)");

  return (
    <Dialog
      fullScreen={isMobile ? true : false}
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
      className="bottom-dialog"
    >
      {isMobile && (
        <div className="bottom-dialog-close">
          <IconButton
            color="inherit"
            onClick={onClose}
            aria-label="close"
            className="iconBtn"
            disabled={disabled}
          >
            <CloseRoundedIcon />
          </IconButton>
        </div>
      )}

      <DialogContent>
        <div
          className="bottom-dialog-container"
          style={{ marginTop: isMobile ? "35px" : 0 }}
        >
          {children}
        </div>
      </DialogContent>
      {isDialogAction && dialogAction}
    </Dialog>
  );
};

export default BottomDialog;
